'use strict';

var sharedDateUtils = require('../date');

module.exports = {
  // Basic `dddd-dd-dd` check.
  isValid: function isValid(date) {
    return !!date && /^\d{4}-\d{2}-\d{2}$/.test(date);
  },

  today: function today() {
    return sharedDateUtils.format(new Date());
  }
};